export default "__VITE_ASSET__CjITyz23__"